(function () {
  if (window.__ottoAnnouncementRotateInit) return;
  window.__ottoAnnouncementRotateInit = true;

  var FADE_MS = 300;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobile() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

  function visibleSlides(viewport) {
    var slides = Array.prototype.slice.call(
      viewport.querySelectorAll('[data-announcement-slide]')
    );
    var mobile = isMobile();
    return slides.filter(function (slide) {
      if (!mobile) return true;
      return slide.getAttribute('data-show-mobile') !== 'false';
    });
  }

  function setActive(slides, index) {
    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === index);
    });
  }

  function initViewport(viewport) {
    if (viewport.dataset.announcementReady === 'true') return;
    viewport.dataset.announcementReady = 'true';

    var autorotate = viewport.getAttribute('data-autorotate') === 'true';
    var interval = parseInt(viewport.getAttribute('data-interval'), 10) || 5000;
    var timer = null;
    var index = 0;
    var paused = false;

    function slides() {
      return visibleSlides(viewport);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function tick() {
      var list = slides();
      if (list.length < 2) return;
      index = (index + 1) % list.length;
      setActive(list, index);
    }

    function start() {
      stop();
      var list = slides();
      if (!autorotate || prefersReducedMotion() || paused || list.length < 2) {
        return;
      }
      timer = window.setInterval(tick, interval);
    }

    function pause() {
      paused = true;
      stop();
    }

    function resume() {
      paused = false;
      start();
    }

    function applyReducedMotion() {
      viewport.classList.toggle('announcement-bar__viewport--reduced', prefersReducedMotion());
      var list = slides();
      if (!list.length) return;

      if (prefersReducedMotion()) {
        stop();
        if (isMobile()) {
          setActive(list, 0);
        } else {
          list.forEach(function (slide) {
            slide.classList.add('is-active');
          });
        }
        return;
      }

      list.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === 0);
      });
      index = 0;
      start();
    }

    viewport.addEventListener('mouseenter', pause);
    viewport.addEventListener('mouseleave', resume);
    viewport.addEventListener('focusin', pause);
    viewport.addEventListener('focusout', function (event) {
      if (!viewport.contains(event.relatedTarget)) resume();
    });

    var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (motionQuery.addEventListener) {
      motionQuery.addEventListener('change', applyReducedMotion);
    } else if (motionQuery.addListener) {
      motionQuery.addListener(applyReducedMotion);
    }

    window.addEventListener('resize', function () {
      window.clearTimeout(viewport.__ottoResizeTimer);
      viewport.__ottoResizeTimer = window.setTimeout(applyReducedMotion, FADE_MS);
    });

    applyReducedMotion();
  }

  function initAll() {
    document.querySelectorAll('[data-announcement-rotate]').forEach(initViewport);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
